import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-game-categories-selector-footer-student',
  templateUrl: './game-categories-selector-footer-student.component.html',
  styleUrls: ['./game-categories-selector-footer-student.component.scss']
})
export class GameCategoriesSelectorFooterStudentComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  openDocs() {
    alert("Is it new overlay or other page?");
  }
}
